import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: false,
  qualifiche: [],
  currentQualificaId: null,
  caricamentoSupp: false,
  qualificheSupp: [],
  idRating: 0,
};

const ratingSlice = createSlice({
  name: 'rating',
  initialState,
  reducers: {
    setIdRating: (state, action) => {
      state.idRating = action.payload;
    },
    setCaricamentoInCorso: (state, action) => {
      state.caricamentoInCorso = action.payload;
    },
    setQualifiche: (state, action) => {
      state.qualifiche = action.payload;
    },
    setCurrentQualificaId: (state, action) => {
      state.currentQualificaId = action.payload;
    },
    setCaricamentoSupp: (state, action) => {
      state.caricamentoSupp = action.payload;
    },
    setQualificheSupp: (state, action) => {
      state.qualificheSupp = action.payload;
    },
  },
});

export const { setCaricamentoInCorso, setQualifiche, setCurrentQualificaId, setCaricamentoSupp, setQualificheSupp, setIdRating } = ratingSlice.actions;

const ratingReducer = ratingSlice.reducer;

export default ratingReducer;
